import { render, staticRenderFns } from "./pack.vue?vue&type=template&id=4a1b5be5"
import script from "./pack.vue?vue&type=script&lang=js"
export * from "./pack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports